import React from 'react';
import styled from 'styled-components';

import SpecialIcon from '@lt/components/icons-react/hotel-includes/Special';
import { i18n } from '@lt/localization';
import { CustomBooleanFilterGroup } from 'src/routes/SeoApp/presentation/FiltersSection/components/FiltersHelpers/CustomBooleanFilterGroup';
import type { IFilter } from '../types';

const FILTER_NAMES = {
  no_single_men: i18n.t('filters.restrictions.no_single_men.checkbox'),
  adults_only: i18n.t('filters.restrictions.adults_only.checkbox'),
};

const FILTER_DESCRIPTIONS = {
  no_single_men: i18n.t('filters.restrictions.no_single_men.description'),
  adults_only: i18n.t('filters.restrictions.adults_only.description'),
};

const TITLE = i18n.t('filters.restrictions.title');
const RestrictionsFiltersList = Object.keys(FILTER_NAMES);

const getFilterLabel = (isMobile: boolean) => (
  <Label isMobile={isMobile}>
    <LabelText>{TITLE}</LabelText>
    <StyledSpecialIcon isMobile={isMobile} />
  </Label>
);

const FilterRestrictionsComponent = (props: IFilter): JSX.Element => {
  const { isMobile = false } = props;

  const filter = {
    filterLabel: getFilterLabel(isMobile),
    FILTER_NAMES,
    FILTER_DESCRIPTIONS,
    customFilters: RestrictionsFiltersList,
  };

  return <CustomBooleanFilterGroup {...props} Filter={filter} />;
};

const Label = styled.span<{ isMobile: boolean }>`
  display: inline-block;
  ${({ isMobile }) => (isMobile ? 'flex:2' : 'max-width: 150px')}
`;

const LabelText = styled.span`
  margin-right: 3px;
`;

const StyledSpecialIcon = styled(SpecialIcon)<{ isMobile: boolean }>`
  width: 24px;
  height: 24px;
  position: ${({ isMobile }) => (isMobile ? 'relative' : 'absolute')};
  ${(props) => (props.isMobile ? 'vertical-align:top;' : null)}
`;

// TODO: костыль который ждет доработок с бэка
const isShowFilter = (data) => {
  const { no_single_men: noSingleMenArray } = data;

  return noSingleMenArray ? noSingleMenArray[1].hotel_count > 0 : false;
};

export const FilterRestrictions = Object.assign(FilterRestrictionsComponent, {
  FILTER_NAMES,
  filterName: 'restrictions',
  customFilters: RestrictionsFiltersList,
  customConditionToShow: isShowFilter,
});
